import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Grid from "material-ui-next/Grid";
import Typography from "material-ui-next/Typography";
import { Loadable, CardValue, CurrencyValue } from "components/support";

import { fn } from "util";

export default class TotalsView extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  render() {
    const { totals, loading } = this.props.viewModel;
    return (
      <Grid container spacing={16} className="full-height">
        <Grid item xs>
          <Paper elevation={1} className="p-sm text-center full-height">
            <Loadable loading={loading}>
              <Typography type="headline">Quantidade em Estoque</Typography>
              <CardValue positive={totals.stock_count > 0}>
                {fn.centsToReal(totals.stock_count * 100)}
              </CardValue>
            </Loadable>
          </Paper>
        </Grid>
        <Grid item xs>
          <Paper elevation={1} className="p-sm text-center full-height">
            <Loadable loading={loading}>
              <Typography type="headline">Custo do Estoque</Typography>
              <CardValue positive={totals.stock_value > 0}>
                <CurrencyValue value={totals.stock_value} type="money" />
              </CardValue>
            </Loadable>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/totals/view.jsx